import * as React from 'react';
import { cn } from 'src/shadcn/lib/utils';
import { Icon, IIconProps } from '../Icon';

interface IRowItemSharedProps {
  onClick?: () => void;
  containerClassName?: string;
  iconClassName?: string;
}

interface IRowItemIconProps1 extends IRowItemSharedProps {
  type: 'icon';
  iconProps: IIconProps;
}

interface IRowItemIconProps2 extends IRowItemSharedProps {
  type: 'emoji';
  emoji: string;
}

export type IRowItemIconProps = IRowItemIconProps1 | IRowItemIconProps2;

export const RowItemIcon: React.FunctionComponent<
  IRowItemIconProps
> = props => {
  return (
    <div
      className={cn(
        props.containerClassName,
        'flex rounded text-center text-base',
        {
          ['cursor-pointer hover:bg-white']: Boolean(props.onClick),
        }
      )}
      onClick={props.onClick}
    >
      <div
        className={cn(
          'm-auto flex flex-row justify-center',
          props.iconClassName
        )}
      >
        {props.type === 'emoji' ? props.emoji : <Icon {...props.iconProps} />}
      </div>
    </div>
  );
};
